import React, { useEffect, useState } from 'react';

import Card from '../Card/Card';

import * as styles from './Selected.module.scss';
import CardWrap from '../Card/CardWrap';

interface SelectedProps {
  card: any;
  onClose: Function;
};

const Selected: React.FC<SelectedProps> = ({ card, onClose }) => {
  const [show, setShow] = useState(false);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const wWidth = window.innerWidth;
    const wHeight = window.innerHeight;

    if (wWidth > wHeight) {
      setWidth((wHeight * 0.625) * 0.8);
    } else {
      setWidth(wWidth * 0.8)
    }

    const timer = setTimeout(() => {
      setShow(true);
    });

    return () => clearTimeout(timer);
  }, []);

  const setClose = () => {
    setShow(false);

    setTimeout(() => {
      onClose()
    }, 500);
  };

  return (
    <div className={`${show && styles.show} ${styles.wrapper}`}>
      <div className={styles.overlay} onClick={() => setClose()}/>
      <div className={styles.content}>
        <CardWrap width={width}>
          <Card {...card} animate/>
        </CardWrap>
      </div>
    </div>
  );
};

export default Selected;
